module.exports = __webpack_public_path__ + "static/media/land_colored_icon.080c9049.svg";